module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Gamepad1-fbc8841d6c73d74c7d7cd990c6ab0f39.svg";